import { render, staticRenderFns } from "./LicenseMeta.vue?vue&type=template&id=420e4641&scoped=true"
import script from "./LicenseMeta.vue?vue&type=script&lang=js"
export * from "./LicenseMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420e4641",
  null
  
)

export default component.exports